import { render, staticRenderFns } from "./AdditionalServicePricePage.vue?vue&type=template&id=2bafcf3e&scoped=true&"
import script from "./AdditionalServicePricePage.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicePricePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafcf3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bafcf3e')) {
      api.createRecord('2bafcf3e', component.options)
    } else {
      api.reload('2bafcf3e', component.options)
    }
    module.hot.accept("./AdditionalServicePricePage.vue?vue&type=template&id=2bafcf3e&scoped=true&", function () {
      api.rerender('2bafcf3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/AdditionalServicePricePage.vue"
export default component.exports